import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-light text-muted mt-5 py-4">
      <Container>
        <Row>
          <Col md={6}>
            <p>&copy; {new Date().getFullYear()} Fluybuy GmbH</p>
          </Col>
          <Col md={6} className="text-md-end">
            <Link to="/about" className="me-3 text-decoration-none">
              Über uns
            </Link>
            <Link to="/legal" className="text-decoration-none">
              Impressum &amp; AGB
            </Link>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
